<div class='button-group'>
  <slot />
</div>

<style>
.button-group {
  display: flex;
  height: fit-content;
  gap: var(--spacing--xs);
}
</style>
